var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tips"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label)+":")]),_c('span',{staticClass:"text pl-2"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }